import { render, staticRenderFns } from "./JourneyDetailMember.vue?vue&type=template&id=d89359f0&scoped=true"
import script from "./JourneyDetailMember.vue?vue&type=script&lang=js"
export * from "./JourneyDetailMember.vue?vue&type=script&lang=js"
import style0 from "./JourneyDetailMember.vue?vue&type=style&index=0&id=d89359f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89359f0",
  null
  
)

export default component.exports